<div class="row">
    <div class="col-md-12 text-end">
        <h3 class="organization_title mt-5">
            Organization Name <span>{{ currentOrganizationName }}</span>
        </h3>
    </div>
</div>
<div class="row m-0 w-100">
    <div class="col-md-4 user_number">
        <p>
            Users: <span>{{ userListToBeDisplay.length }}</span>
        </p>
    </div>
    <div class="col-md-8 text-end grid-list search-wrapper">
        <!-- <mat-form-field style="width: auto">
                <input matInput type="text" placeholder="Enter a search item" [(ngModel)]="searchText" (keyup)="searchResult($event)" autocomplete="off" />
                <button mat-button matPrefix mat-icon-button class="search_btn">
                    <mat-icon class="serach_icon">search</mat-icon>
                </button>
            </mat-form-field> -->
        <mat-form-field class="mat-filed" [floatLabel]="'never'">
            <input
                matInput
                type="text"
                placeholder="{{ 'SELECT_ORG_PAGE.LABELS.SEARCH' | transloco }}"
                [(ngModel)]="searchText"
                (keyup)="searchResult($event)"
                autocomplete="off"
            />
            <button mat-button matPrefix mat-icon-button class="search_btn">
                <mat-icon>search</mat-icon>
            </button>
        </mat-form-field>
        <button type="button" class="btn primary-ebtn" *ngIf="hideAddOption === true" (click)="openCustomModal()">Add New User</button>
        <!-- <button (click)="openCustomModal();">DEMO MODAL</button> -->
        <div class="d-flex align-items-center">
            <a href="javascript:void(0)" (click)="handleUserView(0)" matTooltip="Grid" [matTooltipPosition]="tooltip_position"
                ><i class="fa fa-th-large" aria-hidden="true" [ngStyle]="{ color: div1 == true ? '#000' : '#696869' }"></i
            ></a>
            <a href="javascript:void(0)" (click)="handleUserView(1)" matTooltip="List" [matTooltipPosition]="tooltip_position"
                ><i class="fa fa-list" aria-hidden="true" [ngStyle]="{ color: div1 == false ? '#000' : '#696869' }"></i
            ></a>
        </div>

        <ng-template #mymodal1 let-modal>
            <div class="modal-header">
                <h4>Add User</h4>
                <a class="close-icon" href="javascript:void()" ngbAutofocus (click)="modal.close('Ok click')"><i class="flaticon2-cross"></i></a>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn primary-ebtn">Add</button>
                <button type="button" class="btn secondary-ebtn" (click)="modal.close('Ok click')">Cancel</button>
            </div>
        </ng-template>
    </div>
</div>

<div class="row" *ngIf="securityRoleWiseUser && isGridView; else listView">
    <!-- {{ securityRoleWiseUser[0].userList.length }} -->
    <div
        class="col-md-2 user-card-view"
        *ngFor="let userRole of securityRoleWiseUser; let i = index"
        [ngClass]="i + 1 < securityRoleWiseUser.length ? 'broder-bottom' : ''"
        style="width: 100%; margin: 10px 0px"
        [class.col-md-6]="isGridView !== true"
        [class.col-md-12]="isGridView"
    >
        <div class="row">
            <div class="col mb-5">
                <h4>{{ userRole.secuirtyRoleName }} :</h4>
            </div>
        </div>
        <div class="row">
            <div class="mb-5" *ngFor="let user of userRole.usersList" [class.col-md-12]="div1 !== true" [class.col-md-2]="div1">
                <div class="user_card">
                    <mat-icon
                        #tooltip="matTooltip"
                        *ngIf="hideEditOption === true"
                        class="mat-icon-edit"
                        matTooltip="Edit"
                        [matTooltipPosition]="tooltip_position"
                        (click)="editUser(user)"
                    >
                        edit</mat-icon
                    >
                    <mat-icon #tooltip="matTooltip" matTooltip="View" *ngIf="hideEditOption != true" class="mat-icon-view" (click)="viewUser(user)">
                        remove_red_eye
                    </mat-icon>
                    <mat-icon
                        #tooltip="matTooltip"
                        class="mat-icon-delete"
                        matTooltip="Delete"
                        *ngIf="hideDeleteOption === true"
                        [matTooltipPosition]="tooltip_position"
                        (click)="deleteUser(user)"
                        >delete</mat-icon
                    >
                    <div class="user_img" *ngIf="!user.image; else user_profile_image">
                        <!-- <ngx-avatars name="{{ user.firstName }} {{ user.lastName }} {{ i }}" initialsSize="3"
                            [round]="true" [size]="avatarSize" bgColor="#ffcc01" fgColor="#010101">
                        </ngx-avatars> -->
                        <div
                            class="custom-avatar"
                            [ngStyle]="{
                                width: avatarSize + 'px',
                                height: avatarSize + 'px',
                                backgroundColor: '#ffcc01',
                                color: '#010101',
                                fontSize: avatarSize / 3 + 'px',
                                borderRadius: '50%',
                            }"
                        >
                            {{ getInitials(user.firstName + ' ' + user.lastName + ' ' + i) }}
                        </div>
                    </div>
                    <ng-template #user_profile_image>
                        <div class="user_img" *ngIf="!user.image">
                            <img [src]="user.image" />
                        </div>
                    </ng-template>
                    <div [ngClass]="div1 ? null : 'user_details'">
                        <h3 matTooltip="{{ user?.firstName?.length > 15 ? user?.firstName : null }}">
                            {{ user?.firstName }}
                        </h3>
                        <h3 matTooltip="{{ user?.lastName?.length > 15 ? user?.lastName : null }}">
                            {{ user?.lastName }}
                        </h3>
                        <p>{{ user.securityRoleName }}&nbsp;</p>
                        <div class="user-email">
                            <p
                                class="email-wrap"
                                *ngIf="div1 !== true"
                                (mouseenter)="manageHover(0)"
                                (mouseout)="manageHover(1)"
                                matTooltip="{{ user?.userEmail?.length > 30 ? user?.userEmail : null }}"
                            >
                                {{ user?.userEmail }}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<ng-template #listView>
    <div class="row" style="width: 100%; margin: 0 auto">
        <div class="col-12" *ngFor="let userRole of securityRoleWiseUser; let i = index">
            <h4 class="mb-4 mt-4">{{ userRole.secuirtyRoleName }} :</h4>
            <div class="row">
                <div class="col-12" [ngClass]="i + 1 < securityRoleWiseUser.length ? 'broder-bottom' : ''">
                    <div class="row">
                        <div class="col-xl-6 col-lg-6 col-md-12 col-12" *ngFor="let user of userRole.usersList">
                            <div class="mb-5">
                                <div class="user_card-list">
                                    <div class="user_img" *ngIf="!user.image; else user_profile_image">
                                        <!-- <ngx-avatars
                                            name="{{ user.firstName }} {{ user.lastName }} {{ i }}"
                                            initialsSize="3"
                                            [round]="true"
                                            [size]="avatarSize"
                                            bgColor="#ffcc01"
                                            fgColor="#010101"
                                        >
                                        </ngx-avatars> -->
                                        <div
                                            class="custom-avatar"
                                            [ngStyle]="{
                                                width: avatarSize + 'px',
                                                height: avatarSize + 'px',
                                                backgroundColor: '#ffcc01',
                                                color: '#010101',
                                                fontSize: avatarSize / 3 + 'px',
                                                borderRadius: '50%',
                                            }"
                                        >
                                            {{ getInitials(getUserDisplayName(user, i)) }}
                                        </div>
                                    </div>
                                    <div class="userlistdetail">
                                        <div class="details">
                                            <div [matTooltipDisabled]="!checkIsTextOverflow('firstName', user?.userId)" matTooltip="{{ user?.firstName }}">
                                                <h4 id="{{ user?.userId }}-first-name">{{ user?.firstName }}</h4>
                                            </div>
                                            <div [matTooltipDisabled]="!checkIsTextOverflow('lastName', user?.userId)" matTooltip="{{ user?.lastName }}">
                                                <h4 id="{{ user?.userId }}-last-name">
                                                    {{ user?.lastName }}
                                                </h4>
                                            </div>
                                            <p
                                                id="{{ user?.userId }}-role"
                                                [matTooltipDisabled]="!checkIsTextOverflow('role', user?.userId)"
                                                matTooltip="{{ user.securityRoleName }}"
                                            >
                                                {{ user.securityRoleName }}&nbsp;
                                            </p>
                                            <p
                                                [matTooltipDisabled]="!checkIsTextOverflow('email', user?.userId)"
                                                matTooltip="{{ user?.userEmail }}"
                                                id="{{ user.userId }}-email"
                                                class="email-wrap"
                                                (mouseenter)="manageHover(0)"
                                                (mouseout)="manageHover(1)"
                                            >
                                                {{ user?.userEmail }}
                                            </p>
                                            <div class="action-icons">
                                                <mat-icon
                                                    #tooltip="matTooltip"
                                                    *ngIf="hideEditOption === true"
                                                    class="mat-icon-edit"
                                                    matTooltip="Edit"
                                                    [matTooltipPosition]="tooltip_position"
                                                    (click)="editUser(user)"
                                                >
                                                    edit
                                                </mat-icon>
                                                <mat-icon
                                                    #tooltip="matTooltip"
                                                    matTooltip="View"
                                                    *ngIf="hideEditOption != true"
                                                    class="mat-icon-view"
                                                    (click)="viewUser(user)"
                                                >
                                                    remove_red_eye
                                                </mat-icon>
                                                <mat-icon
                                                    #tooltip="matTooltip"
                                                    class="mat-icon-delete"
                                                    matTooltip="Delete"
                                                    *ngIf="hideDeleteOption === true"
                                                    [matTooltipPosition]="tooltip_position"
                                                    (click)="deleteUser(user)"
                                                >
                                                    delete
                                                </mat-icon>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-6"></div>
    </div>
</ng-template>

<p *ngIf="userListToBeDisplay?.length === 0" style="margin: 30px; width: 100%; text-align: center; font-size: 30px; color: #ccc">
    Please add user(s) to the Organization
</p>
